// @core/api/endpoints/localization/list_namespaces.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListNamespacesResponse,
} from '../../../types/localization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/localization';

/**
 * List translation namespaces
 * Returns all translation namespaces. Supports filtering by product and scope.
 */
export async function ListNamespaces(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListNamespacesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/namespaces`;
  const requestOptions = options;
  return client.get<ListNamespacesResponse>(requestPath, { ...requestOptions, params });
}
